import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';

const KEY = ['cashbox', 'list'];

export function useCashboxes() {
  return useQuery({
    queryKey: KEY,
    queryFn: async () => {
      const { data } = await api.get('/cashbox');
      return data?.cashboxes || data?.data || data || [];
    },
    staleTime: 15_000
  });
}

export function useCashbox(id) {
  return useQuery({
    queryKey: ['cashbox', 'one', id],
    queryFn: async () => {
      const { data } = await api.get(`/cashbox/${id}`);
      return data?.cashbox || data?.data || data;
    },
    enabled: !!id
  });
}

export function useCreateCashbox() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (body) => api.post('/cashbox', body).then((r) => r.data),
    successMessage: 'تم إنشاء القاصة',
    onSuccess: () => qc.invalidateQueries({ queryKey: ['cashbox'] })
  });
}

export function useUpdateCashbox() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ id, body }) => api.patch(`/cashbox/${id}`, body).then((r) => r.data),
    successMessage: 'تم حفظ التعديلات',
    onSuccess: () => qc.invalidateQueries({ queryKey: ['cashbox'] })
  });
}

export function useDeleteCashbox() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (id) => api.delete(`/cashbox/${id}`).then((r) => r.data),
    successMessage: 'تم حذف القاصة',
    onSuccess: () => qc.invalidateQueries({ queryKey: ['cashbox'] })
  });
}

export function useAdjustCashbox() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ id, body }) => api.post(`/cashbox/${id}/adjust`, body).then((r) => r.data),
    successMessage: 'تمت التسوية',
    onSuccess: () => qc.invalidateQueries({ queryKey: ['cashbox'] })
  });
}
